import React, { useEffect } from 'react';
import { useTranslation } from '../components/TranslationContext';
import { Helmet } from 'react-helmet';
import '../styles/savoirfaire.css';
import '../styles/root.css';
import savoirFaireImage1 from '../assets/usine/Marine & Moi-128.jpg';
import savoirFaireImage2 from '../assets/usine/uniforme-cuisine.jpg';
import savoirFaireImage3 from '../assets/usine/Marine & Moi-132.jpg';
import savoirFaireImage4 from '../assets/usine/Marine & Moi-12.jpg';
import savoirFaireImage5 from '../assets/usine/Marine & Moi-145.jpg';
import savoirFaireImage6 from '../assets/usine/chemises.jpg';
import savoirFaireImage7 from '../assets/usine/denim.jpg';

// Scroll-triggered animation
function checkVisibility() {
  const sections = document.querySelectorAll('.section-content');

  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.top <= windowHeight * 0.75 && rect.bottom >= 0) {
      section.classList.add('visible');
    } else {
      section.classList.remove('visible');
    }
  });
}

// Initial check
checkVisibility();

// Add scroll event listener
window.addEventListener('scroll', checkVisibility);

const SavoirFaire = () => {
  const { translate } = useTranslation();
  const savoirfaire = translate('savoirfaire');

  useEffect(() => {
    // Ensure the first section is visible on load
    const firstSection = document.querySelector('.section-content');
    if (firstSection) {
      firstSection.classList.add('visible');
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Marine & Moi - Savoir-Faire</title>
        <meta name="description" content="Découvrez le savoir-faire de Marine & Moi dans la fabrication de vêtements techniques, uniformes de cuisine, vêtements de travail, chemises haut-de-gamme, vêtements en denim, broderies complexes et produits en raphia." />
        <meta name="keywords" content="savoir-faire, vêtements techniques, uniformes de cuisine, vêtements de travail, chemises, denim, broderies, raphia" />
      </Helmet>
      <div className="section-container">
        <div className="section-content visible" data-section="uniformes">
          <div className="section-image">
            <img src={savoirFaireImage1} alt="Uniformes de combat" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.uniformsTitle}</h2>
            <p className="section-description">{savoirfaire.uniformsDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="cuisine">
          <div className="section-image">
            <img src={savoirFaireImage2} alt="Vêtements de cuisine" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.kitchenTitle}</h2>
            <p className="section-description">{savoirfaire.kitchenDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="travail">
          <div className="section-image">
            <img src={savoirFaireImage3} alt="Vêtements de travail" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.workwearTitle}</h2>
            <p className="section-description">{savoirfaire.workwearDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="chemises">
          <div className="section-image">
            <img src={savoirFaireImage6} alt="Chemises haut-de-gamme" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.shirtsTitle}</h2>
            <p className="section-description">{savoirfaire.shirtsDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="denim">
          <div className="section-image">
            <img src={savoirFaireImage7} alt="Vêtements en denim" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.denimTitle}</h2>
            <p className="section-description">{savoirfaire.denimDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="broderies">
          <div className="section-image">
            <img src={savoirFaireImage4} alt="Broderies" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.embroideryTitle}</h2>
            <p className="section-description">{savoirfaire.embroideryDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
        <div className="section-content" data-section="raphia">
          <div className="section-image">
            <img src={savoirFaireImage5} alt="Produits en raphia" />
          </div>
          <div className="section-text">
            <h2 className="section-title">{savoirfaire.raphiaTitle}</h2>
            <p className="section-description">{savoirfaire.raphiaDescription}</p>
            <a href="./Contact" className="section-btn">{savoirfaire.button}</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavoirFaire;
